module.exports = __webpack_public_path__ + "media/images/official/plan_ticket_icon4-9e01de08118d9d3b91f6f70ab9951417.svg";